<template>
  <b-modal id="prompt-modal" centered hide-header-close hide-footer>
    <div
      slot="modal-title"
      :style="{ color: webDesign.design.main_color }"
    >
      {{ parameters.title }}
    </div>
    <b-container>
      <b-row class="my-3">
        <b-col class="text-center">
          {{ parameters.message }}
        </b-col>
      </b-row>
      <b-row class="my-3">
        <b-col class="mx-auto" md="3">
          <b-button
            v-if="webDesign !== null && webDesign.design !== null"
            pill
            block
            :style="{
              backgroundColor: webDesign.design.main_color + '!important',
              border: 'none !important',
              color: webDesign.design.button_text_color + '!important',
            }"
            @click="$root.$emit('bv::hide::modal', 'prompt-modal')"
          >
            {{ parameters.buttonText }}
          </b-button>
        </b-col>
      </b-row>
    </b-container>
  </b-modal>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "PromptModal",
  props: ["parameters"],
  computed: {
    ...mapState("estore", ["webDesign"]),
  },
};
</script>

<style lang="scss">
#prompt-modal {
  .modal-title {
    width: 100%;
    text-align: center;
  }
}
</style>